const Menu = [
  {
    title: "Dashboard",
    group: "apps",
    icon: "fa-tachometer",
    name: "Dashboard"
  },

  {
    title: "Usuários",
    group: "apps",
    icon: "fa-users",
    name: "UserIndex"
  },
  {
    title: "Usuários Temporários",
    group: "apps",
    icon: "fas fa-user-clock",
    name: "TempUsers"
  },
  {
    title: "Romaneios",
    group: "apps",
    icon: "icofont-cow",
    name: "RomaneioIndex"
  },
  {
    title: "Industrias",
    group: "apps",
    icon: "fa-industry",
    name: "IndustryIndex"
  },
  {
    title: "Propriedades",
    group: "apps",
    icon: "fa-leaf",
    name: "PropertyIndex"
  },
  {
    title: "Produtores",
    group: "apps",
    icon: "icofont-farmer",
    name: "ExplorerIndex"
  },
  {
    title: "Auxiliares",
    group: "aux",
    component: "aux",
    icon: "build",
    items: [
      { name: "racas", title: "Raças", component: "AuxBreed" },
      { name: "finish", title: "Acabamento", component: "AuxFinish" },
      { name: "case", title: "Motivos", component: "AuxCase" },
      { name: "category", title: "Categorias", component: "AuxCategory" },
      {
        name: "conformation",
        title: "Tipos de conformação",
        component: "AuxConformation"
      },
      { name: "destiny", title: "Destinos", component: "AuxDestiny" },
      {
        name: "installTarget",
        title: "Locais de instalção",
        component: "AuxInstallTarget"
      },
      { name: "market", title: "Mercados", component: "AuxMarket" },
      { name: "maturity", title: "Maturidades", component: "AuxMaturity" },
      {
        name: "typeNegotiation",
        title: "Tipos de negociação",
        component: "AuxTypeNegotiation"
      },
      {
        name: "typeProduction",
        title: "Tipos de produção",
        component: "AuxTypeProduction"
      }
    ]
  },
  {
    title: "Relatórios",
    group: "reports",
    component: "reports",
    icon: "fas fa-clipboard",
    items: [
      {
        name: "onlineSlaughter",
        title: "Abate ao Vivo",
        component: "ReportOnlineSlaughter"
      }
    ]
  },
  {
    title: "API's",
    group: "apis",
    component: "apis",
    icon: "fas fa-concierge-bell",
    items: [
      {
        name: "Documentations",
        title: "Documentações",
        component: "Documentations"
      }
    ]
  }
];
// reorder menu
Menu.forEach(item => {
  if (item.items) {
    item.items.sort((x, y) => {
      let textA = x.title.toUpperCase();
      let textB = y.title.toUpperCase();
      return textA < textB ? -1 : textA > textB ? 1 : 0;
    });
  }
});

export default Menu;
